import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';

const List = ({ t, ...rest }) => {
	const columns = [
		{
			header: t('MasterFranchisee_Name'),
			accessor: 'name',
			sortable: false
		},		
		{
			header: t('MasterFranchisee_AdminPanel'),
			accessor: 'backOfficeUrl',
			cell: (backOfficeUrl) => (<a target='blank' href={backOfficeUrl}>{t('MasterFranchisee_GotoAdminPanel')}</a>)
		},
		{
			header: t('MasterFranchisee_ParentPortal'),
			accessor: 'frontOfficeUrl',
			cell: (frontOfficeUrl) => (<a target='blank' href={frontOfficeUrl}>{t('MasterFranchisee_GotoParentPortal')}</a>)
		}
	];

	return (
		<Panel>
			<Panel.Body>			
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);